import { render, staticRenderFns } from "./DriverTestimonialSlide.vue?vue&type=template&id=75df2924&"
import script from "./DriverTestimonialSlide.vue?vue&type=script&lang=js&"
export * from "./DriverTestimonialSlide.vue?vue&type=script&lang=js&"
import style0 from "./DriverTestimonialSlide.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports